import TaskPlansSettingsView from "@/components/features/settings/defaults/matter-task-plans/TaskPlansSettingsView";
import { GlobalNotAuthorized } from "@/components/ui";
import { useUser } from "@/components/UserProvider";
import { PAGE_PERMISSION_KEYS } from "@/lib/data/static/permissionOptions";
import { REFERRAL_STATUS_CATEGORY_OPTIONS } from "@/lib/data/static/matterStatics";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_auth/referrals/settings/task-plans")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!hasPagePermission(PAGE_PERMISSION_KEYS.referralsSettingsTaskPlans)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <div className="flex flex-col gap-6">
      <TaskPlansSettingsView
        statusCategories={REFERRAL_STATUS_CATEGORY_OPTIONS}
      />
    </div>
  );
}
